import { render, staticRenderFns } from "./Settlements.vue?vue&type=template&id=215dc44e&scoped=true"
import script from "./Settlements.vue?vue&type=script&lang=js"
export * from "./Settlements.vue?vue&type=script&lang=js"
import style0 from "./Settlements.vue?vue&type=style&index=0&id=215dc44e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215dc44e",
  null
  
)

export default component.exports